import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";
import CursorBlinker from "./CursorBlinker";

export default function RedoAnimText() {
  const textIndex = useMotionValue(0);
  const texts = [
    "I develop Modern Frontend",
    "I bridge gap between ideas & implementation",
    // "I develop dynamic User Experience",
    "I make pixels dance on the screen",
    "I turn coffee into code"
  ];

  const baseText = useTransform(textIndex, (latest) => texts[latest] || "");
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const displayText = useTransform(rounded, (latest) => baseText.get().slice(0, latest));
  const updatedThisRound = useMotionValue(true);
  const textContainerRef = useRef(null);
  const cursorRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const textContainer = textContainerRef.current;

    const updateCursor = () => {
      const textWidth = textContainer.offsetWidth;
      cursor.style.left = `${textWidth}px`;
    };

    const unsubscribe = displayText.onChange(updateCursor);
    return () => unsubscribe();
  }, [displayText]);

  useEffect(() => {
    animate(count, 60, {
      type: "tween",
      duration: 3,
      ease: "easeIn",
      repeat: Infinity,
      repeatType: "reverse",
      repeatDelay: 3,
      onUpdate(latest) {
        if (updatedThisRound.get() === true && latest > 0) {
          updatedThisRound.set(false);
        } else if (updatedThisRound.get() === false && latest === 0) {
          if (textIndex.get() === texts.length - 1) {
            textIndex.set(0);
          } else {
            textIndex.set(textIndex.get() + 1);
          }
          updatedThisRound.set(true);
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span className="relative" ref={textContainerRef}>
      <motion.span className="text-4xl">{displayText}</motion.span>
      <span className="absolute" ref={cursorRef}>
        <CursorBlinker />
      </span>
    </span>
  );
}
